import React from 'react';
import { AuthUserContext } from '../Session';
 
const FirebaseContext = React.createContext();

export const withFirebase = Component => props => (
  <FirebaseContext.Consumer>
    {firebase => <Component {...props} firebase={firebase}/>}
  </FirebaseContext.Consumer>
);

export default FirebaseContext;